import { publicConfig } from "../../config";

export const serviceCore = {
	sgApiConfig: () => ({ baseUrl: publicConfig.SG_API_BASE_URL }),
};
